import { useEffect, useState } from 'react'
import { cn } from '../../app/libs/cn'
import { getColorFromName } from '@/services/jobService'

// โลโก้บริษัท: มีรูปที่อัปโหลดไว้ (logo_url) ก็โชว์รูป ถ้าไม่มีหรือรูปโหลดไม่ขึ้นให้ถอยกลับเป็นตัวอักษรย่อบนพื้นสีจากชื่อบริษัท
// className กำหนดรูปทรง (เช่น rounded-lg / rounded-full / rounded-none) — ใช้ร่วมกันทุกหน้าที่โชว์โลโก้บริษัท
export default function CompanyLogo({
  name,
  logoUrl,
  size = 44,
  className = 'rounded-lg',
  initialsCount = 2,
}: {
  name: string
  logoUrl?: string | null
  size?: number
  className?: string
  initialsCount?: 1 | 2
}) {
  const [failed, setFailed] = useState(false)
  useEffect(() => { setFailed(false) }, [logoUrl])

  const box = 'flex shrink-0 items-center justify-center overflow-hidden'
  if (logoUrl && !failed) {
    return (
      <div className={cn(box, 'border border-[#E7E5FF] bg-white', className)} style={{ width: size, height: size }}>
        <img src={logoUrl} alt={name} className="h-full w-full object-contain" onError={() => setFailed(true)} />
      </div>
    )
  }
  return (
    <div
      className={cn(box, 'font-bold text-white', className)}
      style={{ backgroundColor: getColorFromName(name || 'company'), width: size, height: size, fontSize: size > 40 ? 15 : 13 }}
    >
      {(name || '?').slice(0, initialsCount).toUpperCase()}
    </div>
  )
}
